var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full p-8 overflow-hidden box-border"},[_c('div',{ref:"map",staticClass:"bg-teal-600 w-full h-full rounded-lg shadow overflow-hidden"})])}
var staticRenderFns = []

export { render, staticRenderFns }